import { Container, Row, Col, Button, Image } from 'react-bootstrap';
import { useState, useEffect } from "react";
import { AnalyticsHandle } from '../components/AnalyticsHandle';


function CallToAction({ ctaText }) {

    const [content, setContent] = useState(null);
    const { logAnalyticsEvent, logRegisterClick } = AnalyticsHandle();

    const handleButtonClick = (buttonName = 'cta_primary') => {
        logRegisterClick(buttonName);
        logAnalyticsEvent('cta_button_click', {
            button_name: buttonName,
            timestamp: new Date().toISOString()
        });
        window.open('/register', '_self');
    }

    useEffect(() => {
        fetch("/data/content.json")
            .then((res) => res.json())
            .then((data) => setContent(data))
            .catch((error) => console.error("Error loading JSON:", error));
    }, []);

    const { cta } = content || {};
    const heading = ctaText || cta?.title || 'Zobacz jak to działa w praktyce';

    return (
        <Container className="py-5" style={{ marginTop: '60px', marginBottom: '60px', backgroundColor: '#f8f9fa', borderRadius: '32px', boxShadow: '0 4px 14px rgba(64, 126, 249, 0.3)'}}>
            <Row className='text-md-start'>
                <Col xs={12} md={6} className='d-flex justify-content-center'>
                <Image fluid src={require('../images/macbook.png')} alt="Podgląd systemu eGodziny na laptopie" />
                </Col>

                <Col className='p-5 d-flex flex-column justify-content-center align-items-center align-items-md-start cta-col'>
                <h2 style={{
                    fontSize: '2.2rem',
                    fontWeight: '700',
                    color: '#1f2937',
                    marginBottom: '32px'
                }}>
                    {heading}
                </h2>
                
                <div className="d-flex gap-3 flex-wrap">
                    <Button
                    onClick={() => handleButtonClick()}
                    style={{
                        backgroundColor: '#407EF9',
                        color: 'white',
                        border: 'none',
                        borderRadius: '12px',
                        padding: '16px 32px',
                        fontSize: '1.1rem',
                        fontWeight: '600',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 4px 14px rgba(64, 126, 249, 0.3)'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 6px 20px rgba(64, 126, 249, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 4px 14px rgba(64, 126, 249, 0.3)';
                    }}
                    >
                    Wypróbuj za darmo
                    </Button>

                    <Button
                    onClick={() => window.open('https://calendly.com/krzysztof-warda-egodziny/30min', '_blank')}
                    style={{
                        backgroundColor: 'white',
                        color: '#1f2937',
                        border: '2px solid #e5e7eb',
                        borderRadius: '12px',
                        padding: '16px 32px',
                        fontSize: '1.1rem',
                        fontWeight: '600',
                        transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.borderColor = '#407EF9';
                        e.target.style.color = '#407EF9';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.borderColor = '#e5e7eb';
                        e.target.style.color = '#1f2937';
                    }}
                    >
                    Umów bezpłatne demo
                    </Button>
                </div>
                </Col>
            </Row>
        </Container>
    );
}

export default CallToAction;
